import { keyframes } from 'styled-components';

/**
 * Shared "pulse" keyframe used by status indicators (active state, ambient
 * presence dots, NOW marker). Kept in one place so the rhythm stays
 * consistent across primitives — adjusting the duration here updates every
 * consumer.
 *
 * Pair with `theme.motion.pulse.status` (1.6s) for status pills, or
 * `theme.motion.pulse.slow` (2s) for slower ambient cues.
 */
export const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(0.85); }
`;
